// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__135Ok","cell":"ColumnAccessor_cell__3ilBK","firstCellAccent":"ColumnAccessor_firstCellAccent__37x2Y"};